import Layout from '../components/Layout';
import OficinaMainBanner from '../components/OficinasMainBanner';
import OficinasInfo from '../components/OficinasInfo';
import OficinaHowItWorks from '../components/OficinasHowItWorks';
import OficinasGallery from '../components/OficinasGallery';
import OficinasPlaces from '../components/OficinasPlaces';

function oficinas() {
  return (
    <Layout>
      <OficinaMainBanner />
      <OficinasInfo />
      <OficinaHowItWorks />
      <OficinasGallery />
      <OficinasPlaces />
    </Layout>
  );
}

export default oficinas;
